import React from 'react'
import img1 from '../media/Blog/6_1.png'
import img2 from '../media/Blog/6_2.png'
import img3 from '../media/Blog/6_3.png'
import img4 from '../media/Blog/6_4.png'
import img5 from '../media/Blog/6_5.png'
import img6 from '../media/Blog/6_6.png'
import "./blog5.css"
import { Helmet } from 'react-helmet'


export const Blog6 = () => {
    return (
        <>
            <Helmet>
                <meta charset="UTF-8" />
                {/* <meta name="viewport" content="width=device-width, initial-scale=1"></meta> */}
                <title>Free Certified by Coursera</title>
                <meta name="description" content="If you are student, Coursera giving you a chance to learn from big developers/Professors from most prestigious international companies, universities like Google, Microsoft, etc. If you are student and want to get certified course/specialization from Coursera just follow these steps..." />
                <meta name="keywords" content="cursera, course, platform, free course, mooc, financial aid, nos, coding , coding-competitionanuj bhaiya, aman dhattrwal, amazon, microsoft, google, accenture, about, about karan, contact-me, karan-dhingra, kd, karan, karandhingra, call, phone, message, chandigarh university, cu, student, android, webdevelopment, development, roadmap, strategy, linkedin, github, karan-dhingra.github.io, lct" />
                <meta name="author" content="Karan Dhingra" />
            </Helmet>
            <div className="container-blogs">
                <h1 className="title-top">Free Certified by Coursera</h1>
                <div className="body">
                    <p>Coursera is the one of the best MOOC‘s Platform through which you can learn any thing. You can get any course to learn. If you want to learn new Technology or if you are interested in learning how to do coding or if you are interested in how to write code in python? whats programming Language or you want to learn any other Language like, Chinese, Japanese, Korean or something like that you can do from here.
                    </p>
                    <br />
                    <p>Coursera provide you all course free and paid course. Basically you can learn through any course free of cost but you will not get any certificate. But, Coursera helps students studying in university/Colleges/School to learn and get free certificate too.</p>
                    <br />
                    <p>If you are student, Coursera giving you a chance to learn from big developers/Professors from most prestigious international companies, universities like Google, Microsoft, etc. If you are student and want to get certified course/specialization from Coursera just follow these steps.</p>
                    <br />
                    <h1 className="ul-heading">STEPS TO GET CERTIFIED THROUGH COURSERA</h1>
                    <ul>
                        <li>
                            First create an account on Coursera.
                        </li>
                        <li>
                            <p className="li-para">After making and setting up account choose course which you want to do. suppose you want to do this specialization.</p>
                            <div className="li-image">
                                <img src={img1} style={{ border: "1px solid #00000042" }} alt="img1" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <br />
                        <li>
                            <p className="li-para">You will find written Financial Aid Available written. Click that and press continue to the application.</p>
                            <div className="li-image">
                                <img src={img2} style={{ border: "1px solid #00000042" }} alt="img2" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <li>
                            <p className="li-para">This type of screen will come. You need to fill all of your true details.</p>
                            <div className="li-image">

                                <img src={img3} style={{ border: "1px solid #00000042" }} alt="img-3" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <br />
                        <li>
                            <p className="li-para">After filling this you will found something like this. Just fill the proper details, Annual Income as 0 if you are student and employment status to Student and How much can you afford 0.</p>
                            <div className="li-image">

                                <img src={img4} style={{ border: "1px solid #00000042" }} alt="img-4" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <br />
                        <li>
                            <p className="li-para">Then you will need to answer 3 Questions. 2 of them are</p>
                            <div className="li-image">

                                <img src={img5} style={{ border: "1px solid #00000042" }} alt="img-5" width="700" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <br />
                        <li>
                            <p className="li-para">Select here No if you don’t want to take loan.</p>
                            <div className="li-image">

                                <img src={img6} style={{ border: "1px solid #00000042" }} alt="img-6" width="700" className="li-image" />
                            </div>
                        </li>
                        <br />
                        <br />
                        <li>
                            <p className="li-para">After answering all of these questions submit the application and wait for E-mail. This might take 14 -15 days. Don’t worry if you have filled all of your details proper and true you will be approved from coursera.</p>
                        </li>
                        <br />
                        <br />
                    </ul>
                    <p className="ending-page">If this post helps you like the post and follow for more like these.</p>
                </div>
            </div>
        </>
    )
}

export default Blog6